import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {RESPONSE_STATUS } from '../../utils/constants';
// import {MdAdd, MdRemove} from 'react-icons/md';
// import {TiHeartOutline, TiHeartFullOutline, TiStarFullOutline} from 'react-icons/ti';
import Rating from 'react-star-rating-component';
import ReactGA from 'react-ga';
import './WishlistReviewProduct.css';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import Api from '../../utils/api';

const counterStyle = {
    padding: '0 0.5em',
    fontSize: '9.4px',
    fontWeight: '700'
};

const brandTxtLg = {
    fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
    fontSize: '11.2px',
    fontWeight: '600',
    letterSpacing: '0.3px',
    color: '#272d67',
    lineHeight: '1.5'
};

const txtLg = {
    fontFamily: 'Montserrat',
    fontSize: '11.2px',
    letterSpacing: '0.3px',
    fontWeight: 'normal',
    color: '#272d67',
    lineHeight: '1.5'
};

let prevCount = 0;
let currCount = 0;


class WishlistReviewProduct extends React.PureComponent{

    constructor(props) {
        super(props);

        this.state = {
            heartFilled: props.product.wished ? true : false,
            rating: props.product.rating ? props.product.rating : 0,
            productFeedbackMap: [],
            productFeedbackMapIds: [],
            count: 0,
            addedToCart: false
        };

        this.generateProductName = this.generateProductName.bind(this);
        this.generatePrice = this.generatePrice.bind(this);
        this.handleRatingClick = this.handleRatingClick.bind(this);
        this.handleHeartClick = this.handleHeartClick.bind(this);
        this.addOne = this.addOne.bind(this);
        this.minusOne = this.minusOne.bind(this);
    }

    componentWillMount() {
        this.getProductFeedback();

        this.props.cartData.forEach(element => {
            if(element.id == this.props.product.id){
                this.setState({count:element.quantity,addedToCart:true})
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        if(!nextProps.cartGoodsList.map(product => product.id).includes(this.props.product.id)){
            this.setState({count:0,addedToCart:false})
        }
    }



   generateProductName() {
        let name = this.props.product.name;
        let vendor = this.props.product.vendor;
        if (name.indexOf(vendor) > -1) {
            return name.replace(vendor, '');
        }
    }

    generatePrice(){
        let price_parts = this.props.product ? this.props.product.price.split(".") : 0;
        if(price_parts[1] === "0"){
            price_parts[1] = "00";
        }

        return price_parts[0] + "." + price_parts[1];
    }

    getProductFeedback() {
        const userId = localStorage.getItem("user_id");
        const url = '/api/user-order-products/' + this.props.product.id + '/selected-feedback-options?user-id=' + userId;
        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            if (responseJson) {
                this.setState({ 
                    productFeedbackMap: responseJson.productFeedbackOptionDTOList,
                    productFeedbackMapIds: responseJson.selectedProductFeedbackOptionIds
                });
            }
        }).catch(function(err) {
            alert("There was a problem getting your product feedback. Please refresh the page and try again.");
        });
    }

    handleHeartClick(e) {
        // e.preventDefault();
        e.stopPropagation();
        
        const userId = localStorage.getItem("user_id");
        const url = '/api/product-wishlists';
        const prodId = this.props.product.id;
        if (!this.state.heartFilled) {
            fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-auth-token': Api.auth_tokenManager()
                },
                body: JSON.stringify({
                    'userId': userId,
                    'productId': prodId
                })
            }).then(response => {
                if (response.status === RESPONSE_STATUS.OK) {
                    this.setState({heartFilled: true});
                    // if (process.env.REACT_APP_ENV === 'prod') {
                    //     ReactGA.event({
                    //         category: 'Heart Clicked',
                    //         action: "Click",
                    //         label: this.props.product.name,
                    //         value: 1
                    //     });
                    // }
                } else {
                    alert("There was a problem saving the product to your wishlist. Please try again.");
                }
            });
        } else {
            fetch(url, {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-auth-token': Api.auth_tokenManager()
                },
                body: JSON.stringify({
                    'userId': userId,
                    'productId': prodId
                })
            }).then(response => {
                if (response.status === RESPONSE_STATUS.OK) {
                    this.setState({heartFilled: false});
                    // if (process.env.REACT_APP_ENV === 'prod') {
                    //     ReactGA.event({
                    //         category: 'Heart Unclicked',
                    //         action: "Click",
                    //         label: this.props.product.name,
                    //         value: 1
                    //     });
                    // }
                } else {
                    alert("There was a problem removing the product from your wishlist. Please try again.");
                }
            });
        }
    }

    handleRatingClick(nextValue, prevValue, name) {
        const userId = localStorage.getItem("user_id");
        const url = '/api/product-ratings';
        const prodId = this.props.product.id;

        this.setState({rating: nextValue}, function() {
            fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-auth-token': Api.auth_tokenManager()
                },
                body: JSON.stringify({
                    userId: userId,
                    productId: prodId,
                    rating: this.state.rating
                })
            }).then(response => {
                if (response.status !== RESPONSE_STATUS.OK) {
                    alert("There was a problem saving your rating. Please try again.");
                }
            });
        });
        
    }

    updateShopify = () => {
        this.props.syncProducts(this.props.product.variantId + ":" + prevCount, this.props.product.variantId + ":" + currCount);
    };

    addOne(e){
        e.stopPropagation();
        e.preventDefault();
        let addToCartButton = document.querySelector(".product");

        if(this.state.count === 0) {
            addToCartButton.classList.add('added-to-cart');
            this.setState({addedToCart: true});
        }

        prevCount = this.state.count;
        currCount = this.state.count + 1;
        // this.setState({count: currCount}, this.updateShopify);
        this.setState({count: currCount}, ()=>{
            this.props.saveCartForLater(this.props.product,"goodsAddProduct")
        });

    }

    minusOne(e){
        e.stopPropagation();
        let addToCartButton = document.querySelector(".product");
        if (this.state.count === 1) {
            addToCartButton.classList.remove('added-to-cart');
            this.setState({addedToCart: false});
        }

        e.preventDefault();

        prevCount = this.state.count;
        currCount = this.state.count - 1;

        if(this.state.count > 0){
            // this.setState({ count: currCount}, this.updateShopify);
            this.setState({count: currCount},  ()=>{
                this.props.saveCartForLater(this.props.product,"goodsDeleteProduct")
            });
        }
            
    }

    addToCartLabel(e) {
        e.stopPropagation();
        let addedToCart = !this.state.addedToCart;
        let addToCartButton = document.querySelector(".product");

        if (addedToCart) {
            if (this.state.count === 0) {
                 currCount = this.state.count+1;
                this.setState({ count: currCount}, this.updateShopify)
            }
            addToCartButton.classList.add('added-to-cart');
            this.props.saveCartForLater(this.props.product,"goodsAddProduct")
        }
        else {
            if (this.state.count > 0) {
                prevCount = this.state.count;
                currCount = 0;
                this.setState({ count: currCount}, this.updateShopify);
            }
            addToCartButton.classList.remove('added-to-cart');
            this.props.saveCartForLater(this.props.product)
        }

        this.setState({addedToCart: addedToCart});
    }

    render() {
        let CounterAndAddToCart = styled.div`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        `;

        let CounterHolder = styled.div`
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 105px;
        border-radius: 100px;
        border: solid 2px #f0f0f0;
        color: #272d67;
        margin-right: 2%;
        `;

        let AddToCart = styled.div`
        font-family: "Open Sans", Helvetica, Arial, sans-serif;
        font-size: 14px;
        font-weight: 600;
        color: #272d67;
        display: flex;
        align-items: center;
        flex-basis: 75%;
        `;

        let ProductImageHolder = styled.div`
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin: 1.5em 0;
        `;

        let ProductImage = styled.img`
        max-width: 300px;
        height: 200px;
        width: auto;
        `;

        let ProductInfo = styled.div`
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        justify-content: center;
        width: 100%;
        margin-bottom: 1.5em;
        `;

        let Price = styled.div`
        font-family: Montserrat;
        font-size: 11.2px;
        letter-spacing: 0.3px;
        text-align: center;
        color: #272d67;
        font-weight: bold;
        `;

        const feedback = this.state.productFeedbackMap ? this.state.productFeedbackMap.filter(feedbackOption => {
            return this.state.productFeedbackMapIds.indexOf(feedbackOption.id) > -1;
        }): null;
        const feedbackRender = feedback.map((feedback, index, arr) => {
            
            let option = feedback.option + ", ";
            if (index === arr.length - 1) option = option.slice(0, -2) + ".";
            return option;
        });

        if (this.props.product) {
            return (
                <div className={!this.state.addedToCart ? "product" : "product product-added"} >
                    <div className="product-top-section">
                        {
                            this.props.page === 1 ? 
                            <span className="add-to-wishlist-heart" onClick={this.handleHeartClick}>
                                {this.state.heartFilled ? 
                                <i class="fa fa-heart" aria-hidden="true" style={{fontSize:'18px',color:'#ffad94'}}/>
                                : 
                                <i class="fa fa-heart-o" style={{fontSize:'18px',color:'#ffad94'}} aria-hidden="true"/>
                                }
                            </span> : 
                            null
                        }

                        <ProductImageHolder className="image-holder" >
                            <ProductImage alt={ this.props.product.name }  className="lazyload" data-src={ this.props.product.coverImageSource }/>
                        </ProductImageHolder>
                        <ProductInfo>
                            <div className="product-info">
                                <Price className="price">${ parseInt(this.generatePrice(), 10) }</Price>
                                <div className="brand" style={ brandTxtLg }>{ this.props.product.vendor }</div>
                                <div className="product-name" style={ txtLg }>{ this.generateProductName() }</div>
                            </div>
                        </ProductInfo>
                        
                        {
                            this.props.page === 2 ?
                            <div className="product-review-content">
                                <div className="product-review-my-review">
                                    <span className="my-review">My rating</span>
                                    <Rating
                                        name="product-rating"
                                        starCount={5}
                                        value={this.state.rating}
                                        renderStarIcon={(index, value) => (
                                            <span style={{ marginRight: '10px' }}>
                                            {/* <TiStarFullOutline size={14} /> */}
                                            <i className={index <= value ? 'fa fa-star' : 'fa fa-star-o'} style={{fontSize:'39px'}} />
                                            </span>
                                        )}
                                        starColor="#272d67"
                                        emptyStarColor="#ffffff"
                                        onStarClick={this.handleRatingClick}
                                    />
                                </div>
                                <div className="feedback-body">
                                    { feedbackRender.length > 0 ? feedbackRender : "No feedback provided."}
                                </div>
                            </div> : 
                            null
                        }
                    </div>
                    <div className="product-bottom-section">
                        <CounterAndAddToCart className="counter-add-to-cart" >
                            <CounterHolder className={!this.state.addedToCart ? "counter-holder" : "counter-holder addedCounter"}>
                                <div className="counter">
                                    <span style={{ 'cursor': 'pointer' }} onClick={this.minusOne}><i class="fa fa-minus" style={{fontSize:'11px'}} aria-hidden="true"></i></span>
                                    <span style={counterStyle}>{this.state.count}</span>
                                    <span style={{ 'cursor': 'pointer' }} onClick={this.addOne}><i class="fa fa-plus" style={{fontSize:'11px'}} aria-hidden="true"></i></span>
                                </div>
                            </CounterHolder>
                            <AddToCart className="button-holder">
                                <button className={!this.state.addedToCart ? "cart-button" : "cart-button addedButton"} onClick={this.addToCartLabel.bind(this)}>
                                {
                                    !this.state.addedToCart ?
                                    "Add to Cart" :
                                    "Added to Cart"
                                }
                                </button>
                            </AddToCart>
                        </CounterAndAddToCart>
                    </div>
                    
                </div>
            );
        } else {
            return (<div className="product" style={{visibility:'hidden'}} />);
        }
    }
}


function mapStateToProps(state) {
    const { helloava } = state;
    const { isAuthenticated } = helloava.auth;
    const { cartGoodsCount,cartGoodsList, cartPriceSum } = helloava.myCart;
    return { isAuthenticated,cartGoodsCount,cartGoodsList, cartPriceSum };
}

export default connect(mapStateToProps)(WishlistReviewProduct);



// WEBPACK FOOTER //
// ./src/components/wishlist/WishlistReviewProduct.js